<template>
  <v-app id="search1">
    <v-main>
      <v-container v-show="showParameters" fluid>
       <v-row dense no-gutters> 

      </v-row>

      <v-row>
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="getHuov">Search</v-btn>
          </v-col> 
      </v-row>

      </v-container>

      <v-container fluid>
       <v-btn v-show="!showParameters" class="primary ma-0" small @click="showParameters = true">Show parameters</v-btn> 

      <v-row v-if="results" dense no-gutters>
        <v-card class="px-2">
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"   
           
            >
            <template v-slot:item="props">
              <tr>
              <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)"><a> {{props.item.huis_code}} </a></td>
              <td>{{props.item.stat_code}}</td>
              <td><v-chip :color=props.item.hsbc_level_kleur>{{props.item.hsbc_level}}</v-chip></td>
              <td>{{props.item.hsbc_hotel_id}}</td>
              <td>{{props.item.hsbc_hotel_status}}</td>
              <td @click="updHsbc(props.item.hsbc_encrid)">{{props.item.hsbc_opm}}</td>
              <td @click="updHsbc(props.item.hsbc_encrid)">{{props.item.hsbc_opm_dat}}</td>
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
    </v-container>
    </v-main>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
    <updHsbc ref="updHsbc"></updHsbc>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import updHsbc from "@/views/task/inpt/bookingcom/updHsbc";
 export default {
  components: {
    navBar,
    updHsbc
  },
  data() {
    return {
      results: false,
      showParameters: true,
      items: [],
      param: {},
      untilDatemenu: false,

      search: '',
      headers: [
        {text: 'Acco', value: 'huis_code'},
        {text: 'Status', value: 'stat_code'},
        {text: 'Err / Warn', value: 'hsbc_level'},
        {text: 'Hotel Id', value: 'hsbc_hotel_id'},
        {text: 'Hotel Status', value: 'hsbc_hotel_status'},
        {text: 'Remark', value: 'hsbc_opm'},
        {text: 'Remark date', value: 'hsbc_opm_dat'}
      ]
    }  
  },
  created() {
      this.$axios
      .post("ares/json/ares/task/inpt/bookingcom/getSearch1Param.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSearch1Param"
        },
        getSearch1Param: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getSearch1Param;
        }
      });

  },
  methods: {
    /*
    dateToDMY (dat) {
        return dat ? this.$moment(dat).format('DD-MM-YYYY') : ''
      },
     */ 
     getHuov() {
      this.results = true;
      this.showParameters = false;
      this.$axios
        .post("ares/json/ares/task/inpt/bookingcom/search1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "search1"
          },
          search1: {
            untilDate: this.param.untilDate
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.search1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updHsbc(hsbc_encrid) {
       this.$refs.updHsbc.open(hsbc_encrid);
    },
  }
};

</script> 
